import { render, staticRenderFns } from "./form-header-translation.vue?vue&type=template&id=6d1aa944&scoped=true"
import script from "./form-header-translation.ts?vue&type=script&lang=ts&external"
export * from "./form-header-translation.ts?vue&type=script&lang=ts&external"
import style0 from "./form-header-translation.vue?vue&type=style&index=0&id=6d1aa944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1aa944",
  null
  
)

export default component.exports